import { ContextualField } from '@models/ContextualField';
import { guidEmpty } from '../../../common/constants';
import { PropertyType } from '../../../models/enum';

export const referenceGroupField: ContextualField = {
    propertyName: 'referenceGroupProperty',
    icon: 'fa-code-fork fa-rotate-180',
    label: 'Reference group',
    modelName: 'referenceGroup',
    propertyType: PropertyType.Group,
    extraData: {
    },
    isValid: (value: string) => {
        return {
            'required': !!value && value !== guidEmpty
        };
    },
    messages: [
        { key: 'required', value: 'A reference group is required' }
    ]
};